import { configureStore } from '@reduxjs/toolkit';
import vicinityMapReducer from 'features/vicinityMapSlice';

const store = configureStore({
  // add reducer function from vicinityMapSlice to the store
  // this tells the store to use this slice reducer func to handle all state updates
  reducer: { vicinityMap: vicinityMapReducer },
  // disable serializable for Info Window position (Google Maps LatLng type)
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
